export default [
  {
    name: 'fixed_deposit',
    path: '/fixed_deposit',
    component: () =>
      import(/* webpackChunkName: "fixed_deposit" */ './FixedDepositManage.vue')
  },
  {
    name: 'cbm_fx_rate',
    path: '/cbm_fx_rate',
    component: () =>
      import(/* webpackChunkName: "financial" */ './CBMFXRate.vue')
  },
  {
    name: 'matured-f-manual-review-list',
    path: '/matured_fd_manual_review',
    component: () =>
      import(
        /* webpackChunkName: "matured-f-manual-review-list" */ '@/projects/teller/views/MyWork/MaturedFDManualReviewList.vue'
      )
  }
]
